import React, { useState } from 'react';
import { Upload, Button, notification, Progress, Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import { downFile } from '@utils/xhrDownload';
import frontEndUpload, { attachmentSignUrl } from '@utils/uploadFromFE';
import { updateMetaData } from '@service/resumeDetail';
import ModuleView from '../../ModuleView';

import './index.scss';

const Helper = Upload.helper;
const ACCEPT_TYPES = ['.rar', '.zip', '.7z', '.pdf'];

function SampleReel(props) {
  const { type, data } = props;
  const { campusResumeDetail, socialResumeDetail } = useRootStore();

  let store;
  if (type === 'campus') store = campusResumeDetail;
  if (type === 'social') store = socialResumeDetail;
  const [loading, setLoading] = useState(false);
  const [percentage, setPercentage] = useState(0);

  // 进度条
  const handleClick = () => {
    setPercentage(0);
    let value = 0;
    const f1 = () => {
      setTimeout(() => {
        if (value < 99) {
          value += 1;
          setPercentage(value);
          f1();
        }
      }, 20);
    };
    f1();
  };

  /**
   * 上传附件前回调
   */
  const onBeforeUpload = (files: File[]) => {
    if (store.resumeWorksAttachmentList && store.resumeWorksAttachmentList.length + files.length > 4) {
      notification.error({
        title: '错误',
        message: '最多只能上传4个作品集',
      });
      return false;
    }
    for (const file of files) {
      const fileName = file.name.split('.');
      const fileType = `.${fileName[fileName.length - 1]}`;
      if (!ACCEPT_TYPES.includes(fileType)) {
        notification.error({
          title: '错误',
          message: '不支持上传该文件类型的文件！',
        });
        return false;
      }

      if (Helper.getFileSizeWithMB(file) > 150) {
        notification.error({
          title: '错误',
          message: '附件简历大小限制为150M，请重新上传',
        });
        return false;
      }
    }

    setLoading(true);
    handleClick();
    return true;
  };

  const handleIconImg = (param: string) => {
    if (param === 'pdf') return require('../../../../../../imgs/pdf.svg');
    if (param === 'zip' || param === 'rar' || param === '7z') return require('../../../../../../imgs/zip.svg');
    return require('../../../../../../imgs/unknow.svg');
  };

  /**
   * 上传附件失败
   */
  const onError = (error: string) => {
    console.log('上传失败, error:', error);
    notification.error({
      title: '错误',
      message: '上传失败, 请切换网络后刷新页面重试',
      // message: error || '上传简历失败',
    });
  };

  const handleUpload = (file: File) => {
    return new Promise((resolve, reject) => {
      frontEndUpload({
        signUrl: `${attachmentSignUrl}?fileTypeCode=2`,
        accept: ACCEPT_TYPES,
        file,
        onError: (error) => {
          onError(error);
          reject();
        },
        onFileInfo: async (fileInfo) => {
          const { key, fileName, fileType, fileSize } = fileInfo;
          // 先通知后端更新元数据
          await updateMetaData({ fileId: key, fileName, fileSize, fileTypeCode: '2' });

          const param = {
            fileId: key,
            name: fileName,
            type: fileType?.split('/')[1],
            unionId: '',
            fileTypeCode: '2',
          };
          store.addResumeList('resumeWorksAttachmentList', param);
          resolve('');
        },
      });
    });
  };

  const onUpload = (files: File[]) => {
    if (onBeforeUpload(files)) {
      Promise.all(files.map(handleUpload)).then(() => {
        setLoading(false);
      });
    }

    return false;
  };

  return (
    <div className="upload_sample_reel_edit model_edit">
      <div className="model_title">作品集</div>
      <div className="sample_list">
        {data?.map((item, index) => (
          <div className="model_list" key={item.renderId}>
            <img className="icon" src={handleIconImg(item.type)} alt="" />
            <div className="name">{item.name}</div>
            <div className="list_icon">
              <Icon
                type="download-o"
                onClick={() => {
                  downFile(item.fileId, item.name, store.resumeUnionId);
                }}
              />
              <Icon type="delete-o" onClick={() => store.deleteResumeList('resumeWorksAttachmentList', index)} />
            </div>
          </div>
        ))}
      </div>

      <Upload className="draggable-upload" draggable onBeforeUpload={onUpload} multiple accept=".rar,.zip,.7z,.pdf">
        {loading && <div className="info_1">上传中</div>}
        {!loading && <div className="info_1">点击上传或将你的作品集&其他附件拖拽至此区域</div>}
        {!loading && <Button>上传附件</Button>}
        {loading && (
          <div className="progress-box">
            <Progress className="progress-base" percentage={percentage} color="#FFD000" />
          </div>
        )}
        {!loading && <div className="info_2">支持rar/zip/7z/pdf格式（150M以内）</div>}
      </Upload>
    </div>
  );
}

export default ModuleView(observer(SampleReel), 'sampleReels');
